export const QUICK_ACTIONS_RIBBON_PADDING = 4;
